import { makeImmutable } from "../../core";
export class MinimumValueOrderSelector {
    constructor(minimumValue) {
        this.type = "MinimumValue";
        this.minimumValue = minimumValue;
        makeImmutable(this);
    }
    test(target) {
        const value = target.price.finalValue;
        if (value) {
            return value.geq(this.minimumValue);
        }
        return false;
    }
}
